import styled from 'styled-components';

export const PlayActionEvent = styled.div`
  color: var(--gameday-secondary-font-color);
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const PlayActionDescription = styled.div`
  color: var(--gameday-primary-font-color);
  font-size: 18px;
  font-weight: 500;
`;

export const PlayActionWrapper = styled.div`
  ${({ multipleChildren }) => multipleChildren ? `
    ${PlayActionEvent} {
      margin-bottom: 2px;
    }
  ` : ''}
`;
